import { z } from 'zod';

export function objectEnvelopeSchema(typeName: string) {
  return z.object({
    object: z.literal(typeName),
  });
}

export function listEnvelopeSchema<T extends z.ZodTypeAny>(itemSchema: T) {
  return z.object({
    object: z.literal('list'),
    data: z.array(itemSchema),
    has_more: z.boolean(),
    // Cursor for the next page: id of the last returned item when has_more is
    // true, else null. Optional so existing routes that don't emit it stay valid.
    next_cursor: z.string().nullable().optional(),
    url: z.string(),
  });
}

export const timestampSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/);

export { ProblemDetailsSchema, ValidationProblemDetailsSchema } from './problem-details';
